import { AxiosInstance } from "axios"

export interface UpdatePayoutConfigApiResponse {
  time: string
  apiStatus: string
  data: {
    taPriceConfigId: number
    payoutConfig: string
    message: string
  }
  errorMessage?: string
  message?: string
}

export interface UpdatePayoutConfigApiRequest {
  payoutConfig: string
}

export function updatePayoutConfigApi(
  params: UpdatePayoutConfigApiRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: `/agent/payout-config`,
    params,
  }) as Promise<{ data: UpdatePayoutConfigApiResponse }>
}
